import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";
import * as Cookies from 'js-cookie';
import * as moment from "moment";
import storage from "local-storage-fallback";

const tokenName: string = 'lap_image_browser';
const tokenHeader: string = 'X-Token';

const templateSettings: object = {
    evaluate: /<@([\s\S]+?)@>/g,
    interpolate: /<@=([\s\S]+?)@>/g,
    escape: /<@-([\s\S]+?)@>/g,
};

const itemsPerPage: number = 10;

@Options({
    template: false,
})
export default class ImageBrowserView extends Marionette.View<Backbone.Model>{
    config?: object;
    loggedIn: boolean;
    images: object[];
    page: number = 1;
    authenticationToken: string = null;

    constructor(options?:object, config?:object) {
        super(options);
        this.config = config || {};

        let page = parseInt(this.getPage(), 10);

        if (page) {
            this.page = page;
        }

        this.authenticationToken = storage.getItem(tokenName) || '';
    }

    onRender() {
        this.isLoggedIn().then(() => {
            return this.loadImages();
        }).then((response) => {
            this.showImages(response);
            $('.spinner').remove();
        }).catch((error) => {
            window.location.href = '/press/login';
        });
    }

    showImages(response) {
        const offset = (this.page - 1) * itemsPerPage;

        let images = response.slice(offset, offset + itemsPerPage);

        for(let item of images) {
            if (item.date) {
                item.nice_date = moment(item.date).format('MMMM D, YYYY');
                item.modal_text = `
                    ID: ${item.id}<br>
                    Category: ${item.category.name || ''}<br>
                    Date: ${item.nice_date}<br>
                    Name: ${item.name}<br>
                    Credit: ${item.credit || ''}<br>
                    Restrictions: ${item.restrictions || ''}<br>
                    Low Res: <a href=&quot;${item.image}-/preview/-/inline/no/&quot;>${item.image}-/preview/-/inline/no/</a><br>
                    High Res: <a href=&quot;${item.image}-/inline/no/&quot;>${item.image}-/inline/no/</a>
                `;
            }
        }

        let pages = [];
        let maxPage = Math.floor(response.length / itemsPerPage);
        for(let i = 0; (i * itemsPerPage)<response.length; i++) {
            if(i > 3 && i < maxPage - 3 && Math.abs(i - (this.page - 1)) > 3) {
                continue;
            }


            let offset = i * itemsPerPage;
            let pageNum = i + 1;
            pages.push({
                number: pageNum,
                min: offset,
                max: Math.min(images.length, offset + itemsPerPage),
                isCurrent: pageNum == this.page,
                link: '/press/images?page=' + pageNum,
            });
        }

        let prevLink = (this.page - 1) <= 0 ? null : '/press/images?page=' + (this.page - 1);
        let nextLink = (this.page + 1) > pages.length ? null : '/press/images?page=' + (this.page + 1);

        const listView = new ListView({
            totalItems: response.length,
            items: images,
            moreThanOnePage: response.length > itemsPerPage,
            hideResultCount: false,
            resultStart: offset,
            resultEnd: Math.min(images.length, offset + itemsPerPage),
            prevLink: prevLink,
            nextLink: nextLink,
            pages: pages,
        });

        listView.render();
    }

    getPage() {
        let name = 'page';
        let url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    ajaxConfig(url: string, method: string = 'GET') {
        const config = {
            url: url,
            method: method,
            headers: {},
        };

        config.headers[tokenHeader] = this.authenticationToken;

        return config;
    }

    loadImages() {
        let deferred = $.Deferred();

        const config = this.ajaxConfig('/press/imagedata');

        $.ajax(config).done((response) => {
            deferred.resolve(response.data);
        }).fail((xhr) => {
            deferred.reject(xhr.responseJSON.data);
        });

        return deferred.promise();
    }

    isLoggedIn() {
        let deferred = $.Deferred();

        const config = this.ajaxConfig('/press/authenticated');

        $.ajax(config).done(() => {
            deferred.resolve(true);
        }).fail(() => {
            deferred.reject(false);
        });

        return deferred.promise();
    }
}

const ListView = Marionette.View.extend({
    el: "[data-js-ui=press-image-list]",

    render: function() {
        const template = _.template(
            $('#press-image-browser-list').html(), templateSettings
        );

        this.$el.html( template(this.options) );
    }
});



// WEBPACK FOOTER //
// ./@modules/views/press-images-view.ts